import { ApiError } from '../../helpers/api';

export const isForbiddenError = (error: Error): boolean => {
  return error instanceof ApiError && error.statusCode === 403;
};

export const isValidationError = (error: Error): boolean => {
  return error instanceof ApiError && error.json?.isValidationError;
};
